export const LANGUAGE_STORAGE_KEY = 'mybeef_language_v1';
export const DEFAULT_LANGUAGE = 'pt-BR';

export const SUPPORTED_LANGUAGES = [
  { code: 'pt-BR', label: 'Português', locale: 'pt-BR' },
  { code: 'es', label: 'Español', locale: 'es-419' },
  { code: 'en', label: 'English', locale: 'en-US' },
];

export const normalizeLanguage = (value) => {
  if (typeof value !== 'string') return null;
  const base = value.trim().toLowerCase().replace(/_/g, '-').split('-')[0];
  return SUPPORTED_LANGUAGES.find(({ code }) => code.toLowerCase().split('-')[0] === base)?.code || null;
};

export const getLanguageLocale = (language) => (
  SUPPORTED_LANGUAGES.find(({ code }) => code === normalizeLanguage(language))?.locale || 'pt-BR'
);

export const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    try {
      const saved = normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
      if (saved) return saved;
    } catch {
      // A preferência do navegador continua disponível sem armazenamento local.
    }
  }
  if (typeof navigator !== 'undefined') {
    const preferences = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const preference of preferences) {
      const supported = normalizeLanguage(preference);
      if (supported) return supported;
    }
  }
  return DEFAULT_LANGUAGE;
};

export const saveLanguagePreference = (language) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // A instância de tradução mantém a escolha em memória nesta sessão.
  }
};
